module.exports = __webpack_public_path__ + "vue-app/img/icon-politique.dbc13f77.svg";